<template>
  <div class="page-cards">
    <rabbey-toolbox
      :filterables="true"
      :buttons-views="listView"
      @change-view="onChangeView"
      @filter-search="onFilterSearch"
    >
      <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por Tipo de Cliente"
          v-model="customer_type"
          filterable
          clearable
          @change="handleChangeCustomerType"
        >
          <el-option
            v-for="item in list_customer_type"
            :key="item.value"
            :value="item.label"
            :label="item.label"
          >
          </el-option>
        </el-select>
      </div>

      <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por Clasificación"
          v-model="customer_clasification"
          filterable
          clearable
          @change="handleChangeClasification"
        >
          <el-option
            v-for="item in list_clasification"
            :key="item.value"
            :value="{ value: item.value, label: item.label }"
            :label="item.label"
          >
          </el-option>
        </el-select>
      </div>

      <!--FILTRO DE SERVICIO AL CLIENTE-->
      <CustomerServiceSelector
        v-model="customers_filter"
        @change="handleChangeCustomerServices"
      />

      <!--FILTRO DE AGENTE DE COBROS-->
      <PaymentAgentSelectorVue
        v-model="cxc_filter"
        @change="handleChangePaymentAgent"
      />
      <!--FILTRO ANTERIOR DE SERVICIO AL CLIENTE-->
      <!-- <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por Servicio al Cliente"
          v-model="customers_filter"
          filterable
          clearable
          @change="handleChangeCustomerServices"
        >
          <el-option
            v-for="item in list_consumer"
            :key="item.Code"
            :value="item.Code"
            :label="item.FullName"
          >
          </el-option>
        </el-select>
      </div> -->
      <!-- <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por Gestor de Cobro"
          v-model="cxc_filter"
          filterable
          clearable
          @change="handleChangeCXC"
        >
          <el-option
            v-for="item in list_cxc"
            :key="item.ID"
            :value="item.ID"
            :label="item.Name"
          >
          </el-option>
        </el-select>
      </div> -->

      <!--FILTRO ANTERIOR DE VENDEDORES-->

      <!-- <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por vendedor"
          v-model="seller_filter"
          filterable
          clearable
          @change="handleChangeSeller"
        >
          <el-option
            v-for="(seller, index) in list_vendors"
            :key="index"
            :value="seller.value"
            :label="seller.label"
          />
        </el-select>
      </div> -->

      <!--FILTRO DE VENDEDORES-->
      <SellerSelector v-model="seller_filter" @change="handleChangeSeller" />

      <!--Filtro de agente de cobros-->

      <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por contrato"
          v-model="status_filter"
          filterable
          clearable
          @change="handleChangeStatus"
        >
          <el-option
            v-for="(s, index) in status_list"
            :key="index"
            :value="s.value"
            :label="s.label"
          />
        </el-select>
      </div>

      <!-- <div class="box mr-5">
        <el-select
          size="mini"
          placeholder="Filtrar por Zona"
          v-model="zone_filter"
          filterable
          clearable
          @change="handleChangeZone"
        >
          <el-option
            v-for="item in list_zone"
            :key="item.Description"
            :value="item.Description"
            :label="item.Description"
          >
          </el-option>
        </el-select>
      </div> -->
    </rabbey-toolbox>

    <el-row>
      <el-col>
        <transition name="slide-fade" mode="out-in">
          <component
            v-bind:is="currentTabComponent"
            :items="items"
            :actions="isCustomerService(actions)"
            :filterList="filterList"
            :search="search"
            :seller_filter="seller_filter"
            :status_filter="status_filter"
            :customers_filter="customers_filter"
            :customer_clasification_filter="customer_clasification_label"
            :zone_filter="zone_filter"
            :cxc_filter="cxc_filter"
            :paginationApi="{
              currentPage: page,
              pageSize: limit,
              total: totalItems,
              pageSizes: pageSizes
            }"
            :loading.sync="loading"
            :loadingCard.sync="loading"
            @card-click-action="handleCommand('cards', $event)"
            @rtable-push-action="handleCommand('table', $event)"
            @update-current-page="handleCurrentPage"
            @update-page-size="handlePageSize"
          ></component>
        </transition>
      </el-col>
    </el-row>

    <dialog-new-interaction-form
      :CustomerData="CustomerData"
      ref="dialogNewInteraction"
      :isInHours="isInHours"
      :clientCode="ClientCode"
      :isItVisible="NewIteractionVisible"
    />
    <dialog-new-request-form
      ref="dialogNewRequest"
      :CurrentClient="CustomerData.ClientCode"
      :AreRequestBlocked="CustomerData.ServiceRequestsBlocked"
    />
    <dialog-new-complaint-form ref="dialogNewComplaint" />
    <deals-form-drawer
      ref="drawerNewDeal"
      :drawer.sync="drawerDeal"
      v-bind="dealBind"
      @close-drawer="drawerDeal = false"
    />
    <customer-detail
      :CustomerData="CustomerData"
      :ChangeActiveName="ChangeActiveName"
      ref="details"
      @RechargeCustomerData="fecthCustomers"
    />
    <edit-customer
      :CustomerData="CustomerData"
      :ChangeActiveName="ChangeActiveName"
      ref="edit"
      @refresh="fecthCustomers"
    />
    <contact-from ref="contact" :drawer.sync="drawerContact" />
    <ObjectiveTasksDialog
      :ActualObjective="ActualObjective"
      :columnTaskCodeFrom="columnTaskCodeFrom"
      :CustomerCode="CustomerCode"
      :ObjectiveTasksDialogVisibility="ObjectiveTasksDialogVisibility"
      :IsInCharged="IsInCharged"
      @ObjectiveTasksDialogClosing="ObjectiveTasksDialogClosing"
    />
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

import ContactFrom from "../contacts/ContactForm";
import customerActions from "@/components/customers/customerActions";
import CustomerListCard from "@/components/customers/CustomerListCard.vue";
import CustomerTable2 from "@/components/customers/CustomerTable2.vue";
import DealsFormDrawer from "@/components/deals/DealsFormDrawer";
import Deal from "@/models/deals/Deal";
import SellerSelector from "@/components/Company/SellerSelectorCodeString.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";
import PaymentAgentSelectorVue from "@/components/Company/PaymentAgentSelector.vue";
import ObjectiveTasksDialog from "@/components/cmi/ObjectivesReport/ObjectiveTasksDialog";

export default {
  name: "CustomersList",

  data() {
    return {
      page: 1,
      limit: 10,
      totalItems: 0,
      list_cxc: "",
      list_zone: "",
      list_consumer: "",
      pageSizes: [10, 30, 50, 100, 500],
      list_clasification: [
        {
          value: "1",
          label: "A"
        },
        {
          value: "2",
          label: "B"
        },
        {
          value: "3",
          label: "C"
        },
        {
          value: "4",
          label: "D"
        },
        {
          value: "5",
          label: "E"
        },
        {
          value: "6",
          label: "F"
        }
      ],
      status_list: [
        {
          value: "0",
          label: "Cerrado"
        },
        {
          value: "1",
          label: "Abierto"
        }
      ],
      list_customer_type: [
        {
          value: "Corporativo",
          label: "Corporativo"
        },
        {
          value: "Gubernamental",
          label: "Gubernamental"
        },
        {
          value: "Usuario final",
          label: "Usuario Final"
        }
      ],
      cxc_filter: "",
      status_filter: "",
      seller_filter: "",
      customers_filter: "",
      customer_clasification: "",
      customer_clasification_label: "",
      customer_type: "",
      zone_filter: "",
      isInHours: false,
      drawerContact: false,
      drawerDeal: false,
      modelDeal: Deal,
      dealBind: {
        isClient: true,
        fromAction: true,
        initModel: Deal
      },
      filterList: [],
      search: null,
      actions: customerActions,
      currentTabComponent: CustomerListCard,
      filter: "",
      listView: [
        {
          icon: "el-icon-s-grid",
          component: CustomerListCard
        },
        {
          icon: "mdi mdi-table-of-contents",
          component: CustomerTable2
        }
      ],
      companyId: this.$store.state.user.user.CompanySelected,
      paramsFilter: {
        companyId: this.$store.state.user.user.CompanySelected,
        Name: undefined,
        CustomerService: undefined,
        AccountReceivable: undefined,
        salesPersonCode: undefined,
        Zone: undefined,
        contract: undefined,
        clasificaction: undefined
      },
      requests: [],
      request: null,
      items: [],
      loading: false,
      CustomerData: {},
      ChangeActiveName: "",
      CustomerCode: "",
      ObjectiveTasksDialogVisibility: false,
      ActualObjective: {},
      columnTaskCodeFrom: "",
      IsInCharged: false,
      ClientCode: "",
      NewIteractionVisible: true
    };
  },
  async created() {
    if (this.$store.state.interactions.list.length <= 0) {
      this.$store.dispatch("interactions/all");
    }

    if (this.$store.state.interactions.list_interaction_code.length <= 0) {
      this.$store.dispatch("interactions/get_interaction_code");
    }

    if (this.$store.state.products.list.length <= 0) {
      this.$store.dispatch("products/all");
    }

    if (this.$store.state.request_types.list.length <= 0) {
      this.$store.dispatch("request_types/all");
    }

    this.fecthCustomers();

    this.getCXC();
    this.getcustomerservices();
    this.Getzone();
    await this.IsHeinCharged().then((resp) => {
      this.IsInCharged = resp;
    });
  },
  components: {
    "dialog-new-interaction-form": () =>
      import(
        /* webpackChunkName: "DialogNewInteractionForm" */ "@/components/interactions/DialogNewInteractionForm.vue"
      ),
    "customer-detail": () =>
      import(/* webpackChunkName: "CustomerDetail" */ "./CustomerDetail.vue"),
    "edit-customer": () =>
      import(/* webpackChunkName: "CustomerDetail" */ "./EditCustomer.vue"),
    "dialog-new-request-form": () =>
      import(
        /* webpackChunkName: "DialogNewRequestForm" */ "@/components/requests/DialogNewRequestForm.vue"
      ),
    "dialog-new-complaint-form": () =>
      import(
        /* webpackChunkName: "DialogNewComplaintForm" */ "@/components/Complaints/DialogNewComplaintForm.vue"
      ),
    DealsFormDrawer,
    SellerSelector,
    CustomerServiceSelector,
    PaymentAgentSelectorVue,
    ContactFrom,
    ObjectiveTasksDialog
  },
  methods: {
    isCustomerService(a) {
      if (
        this.currentUser.Roles.some((r) => {
          return r.Id === 54;
        })
      ) {
        return a;
      } else {
        return a.filter((c) => c.command != "Edit");
      }
    },
    ...mapActions({ getSellers: "sellers/getItems" }),
    fecthCustomers() {
      this.items = [];
      this.loading = true;
      this.$http
        .get("/api/customers", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CompanyId: this.currentCompany,
            SalesPersonCode: this.seller_filter,
            Name: this.search,
            CustomerService: this.customers_filter,
            Contract: this.status_filter,
            AccountReceivable: this.cxc_filter,
            clasificaction: this.customer_clasification.value,
            ClientType: this.customer_type
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;
          this.items = Items;
          this.filterList = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          this.filterList = [];
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeView(component) {
      this.currentTabComponent = component;
    },
    onFilterSearch(s) {
      this.search = s;
      this.paramsFilter.Name = s;
      //this.getCustomerList();
      this.fecthCustomers();
    },
    handleCommand(type, c) {
      let row;
      if (type === "cards") {
        row = c.data;
        this.CustomerData = row;
      } else if (type === "table") {
        row = c.row;
        this.CustomerData = row;
      } else {
        return false;
      }

      switch (c.command) {
        case "view": {
          this.$refs.details.show(row);
          this.ChangeActiveName = "";
          break;
        }

        case "Edit": {
          this.$refs.edit.show(row);
          this.ChangeActiveName = "";
          break;
        }

        case "new_deal": {
          Deal.CustomerCode = row.ClientCode;
          this.dealBind.initModel = Deal;
          this.dealBind.code = row.ClientCode;
          this.drawerDeal = true;

          break;
        }

        case "new_interaction": {
          var hours = new Date().getHours();
          const today = new Date();
          const dayOfWeek = today.getDay();
          const weekdays = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ];

          const currentDay = weekdays[dayOfWeek];
          this.isInHours = hours >= 18 || currentDay == "Sunday" ? true : false;
          this.isInHours =
            hours >= 13 && currentDay == "Saturday" ? true : this.isInHours;

          this.ClientCode = row.ClientCode;
          this.NewIteractionVisible = true;
          this.$refs.dialogNewInteraction.show(row.ClientCode);
          break;
        }

        case "new_request": {
          this.$refs.dialogNewRequest.show(row.ClientCode, row);
          break;
        }

        case "new_contact": {
          this.drawerContact = true;
          this.$refs.contact.model.CustomerCode = row.ClientCode;
          break;
        }
        case "new_complaint": {
          this.$refs.dialogNewComplaint.show(row);
          break;
        }
        case "new_survey": {
          break;
        }
        case "go_to_documents": {
          this.$refs.details.show(row);
          this.ChangeActiveName = "Clients_documents";

          break;
        }

        case "view_task": {
          this.ActualObjective = {
            ObjectiveCombinedId: "Obj-3208",
            ObjectiveShortDescription: "Tareas de Clientes",
            PerpectiveID: 2,
            ObjectiveId: 3208,
            DateInit: "2025-07-22",
            DateEnd: "2099-12-31"
          };
          this.columnTaskCodeFrom = "TT";
          this.CustomerCode = row.ClientCode;
          //this.isInCharged = await this.IsHeinCharged();
          this.ObjectiveTasksDialogVisibility = true;
          break;
        }

        default:
          break;
      }
    },
    getCustomerList() {
      if (this.request !== null && this.request.msg === "Loading...") {
        this.request.cancel();
        this.request.msg = "Cancelled";
        this.requests.push(this.request);
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      this.filterList = [];
      this.$http
        .get(`/api/customers/GetCustomersList`, {
          cancelToken: axiosSource.token,
          params: { ...this.paramsFilter, companyId: this.currentCompany }
        })
        .then((resp /*, { data }*/) => {
          this.filterList = resp.data;
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              message: h("p", null, [
                h("span", null, "Registro no encontrado en esta empresa "),
                h(
                  "i",
                  { style: "color: teal" },
                  "Favor consultelo en otra empresa"
                )
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        });
    },
    handleChangeCXC(cxc) {
      this.paramsFilter.AccountReceivable = cxc;
      //this.getCustomerList();
      this.fecthCustomers();
    },
    handleChangeSeller() {
      this.page = 1;
      this.fecthCustomers();
    },
    handleChangeCustomerServices(customerService) {
      this.paramsFilter.CustomerService = customerService;
      this.page = 1;
      this.fecthCustomers();
      //this.getCustomerList();
    },
    handleChangePaymentAgent(AccountReceivable) {
      this.paramsFilter.AccountReceivable = AccountReceivable;
      this.page = 1;
      this.fecthCustomers();
    },
    handleChangeZone(zones) {
      this.paramsFilter.Zone = zones;
      //this.getCustomerList();
      this.page = 1;
      this.fecthCustomers();
    },
    handleChangeStatus(status) {
      this.paramsFilter.contract = status;
      //this.getCustomerList();
      this.page = 1;
      this.fecthCustomers();
    },
    handleChangeClasification(clasification) {
      this.paramsFilter.clasificaction = clasification.value;
      this.customer_clasification_label = clasification.label;
      this.page = 1;
      this.fecthCustomers();
    },
    handleChangeCustomerType(type) {
      this.customer_type = type;
      this.page = 1;
      this.fecthCustomers();
    },
    getCXC() {
      this.$http
        .get(
          `/api/customers/GetColletor?Option=CXC&CompanyId=${this.currentCompany}`
        )
        .then((resp) => {
          const IsoCat = resp.data.map((i) => {
            return { ID: i.Code, Name: i.Name };
          });
          this.list_cxc = IsoCat;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getcustomerservices() {
      this.$http

        .get(
          `/api/customers/AllCustomerServices?companyCode=${this.currentCompany}`
        )
        .then((resp) => {
          const customerMapers = resp.data.map((i) => {
            return {
              Code: i.Code,
              FullName: i.FullName
            };
          });
          this.list_consumer = customerMapers;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    Getzone() {
      this.$http
        .get("/api/customers/zones")
        .then((resp) => {
          this.list_zone = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleCurrentPage(page) {
      this.page = page;
      /*
      this.getCustomerList();


      */
      this.fecthCustomers();
    },
    handlePageSize(limit) {
      this.limit = limit;
      /*
      this.getCustomerList();

      */
      this.fecthCustomers();
    },
    ObjectiveTasksDialogClosing() {
      this.ObjectiveTasksDialogVisibility = false;
    },
    async IsHeinCharged() {
      let IsHeinChargedPromise = await new Promise((resolve, reject) => {
        this.loadingData = true;
        const parameters = {
          params: {
            employee: this.currentUser.EmployeeId
          }
        };
        this.$http
          .get("/api/departments/IsHeIncharged", parameters)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            this.$message.error(err);
            reject(err);
          });
      });
      return IsHeinChargedPromise;
    }
  },
  computed: {
    ...mapGetters({ list_vendors: "sellers/list_to_select" }),
    getCustomers() {
      return this.customers[this.currentCompany];
    }
  }
};
</script>
